var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.676077 3.86361C0.390176 4.02244 0.21286 4.3238 0.21286 4.65085V8.82833C0.21286 12.0989 1.98602 15.1124 4.84503 16.7008L6.9801 17.8869C7.25209 18.038 7.58282 18.038 7.85481 17.8869L9.98988 16.7008C12.8489 15.1124 14.6221 12.0989 14.6221 8.82832V4.65085C14.6221 4.3238 14.4447 4.02244 14.1588 3.86361L7.85481 0.361378C7.58282 0.21027 7.25209 0.21027 6.9801 0.361378L0.676077 3.86361ZM6.48819 11.4024C6.75196 11.6662 7.17962 11.6662 7.44339 11.4024L11.0457 7.80011C11.3095 7.53634 11.3095 7.10868 11.0457 6.84491C10.7819 6.58113 10.3543 6.58113 10.0905 6.84491L6.96579 9.9696L5.64224 8.64605C5.37847 8.38228 4.95081 8.38228 4.68704 8.64605C4.42327 8.90983 4.42327 9.33749 4.68704 9.60126L6.48819 11.4024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.0cfa5effeb25594d5b0133af5be68a2f.svg";
export { ForwardRef as ReactComponent };